export const en = {
    'image-preview-header': 'Image preview',
    'image-preview-header-with-name': 'Preview of "{name}"',
    'selected-categories-count': {
        one: '{count} category selected',
        some: '{count} categories selected',
        many: '{count} categories selected',
        none: 'Choose category'
    },
    title: 'Image library'
};
